var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTestimonialUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "User_Image",
    "data-name": "User Image",
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_11687",
    "data-name": "Trac\\xE9 11687",
    d: "M25,0A25,25,0,1,1,0,25,25,25,0,0,1,25,0Z",
    fill: "#a99479"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-user-alt",
    "data-name": "Icon awesome-user-alt",
    d: "M11.293,12.7A6.352,6.352,0,1,0,4.941,6.352,6.354,6.354,0,0,0,11.293,12.7Zm5.646,1.412H14.509a7.679,7.679,0,0,1-6.432,0H5.646A5.646,5.646,0,0,0,0,19.762v.706a2.118,2.118,0,0,0,2.117,2.117H20.468a2.118,2.118,0,0,0,2.117-2.117v-.706A5.646,5.646,0,0,0,16.939,14.116Z",
    transform: "translate(13.6 13.5)",
    fill: "#f0efea"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestimonialUser);
export default __webpack_public_path__ + "static/media/testimonialUser.14b23d9a7f2ac4c55490c0722423fd1c.svg";
export { ForwardRef as ReactComponent };